module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guarantee-tab"
  }, [(_vm.specArray.length > 1) ? _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("产品规格")])]) : _vm._e(), _vm._v(" "), (_vm.specArray.length > 1) ? _c('ul', {
    staticClass: "productCon listCPGG"
  }, _vm._l((_vm.specArray), function(spec, index) {
    return _c('li', {
      class: {
        active: index === _vm.tabNum
      },
      on: {
        "click": function($event) {
          _vm.tabLi(spec.id, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(spec.specification) + "\n      ")])
  })) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.overTotal > 0) ? _c('div', {
    staticClass: "overdue"
  }, [_c('span', [_vm._v("已过期数量：" + _vm._s(_vm.overTotal))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "border": "",
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "仓库名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.warehouseName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保质状况",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: (scope.row.leftTime < 0 ? 'color:#FC484F' : 'color:#000')
        }, [_vm._v("\n          " + _vm._s(_vm.getOver(scope.row.leftTime)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.batch) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.num) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "生产日期",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.produceDate) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保质期（天）",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.guaranteePeriod) + "\n        ")]
      }
    }])
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("保质期信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efa1b12a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/product/guarantee-tab.vue
// module id = 1350
// module chunks = 82